export default __webpack_public_path__ + "static/media/placeholder_private01-it-mobile.6beb7287.png";